import { Badge } from "@drs-ops/ui";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { TripPlannerResponse } from "@/types/tripPlanner";

export interface CostCompareCardsProps {
  costs: TripPlannerResponse["costs"];
}

function money(n: number): string {
  return `$${Math.round(n).toLocaleString("en-US")}`;
}

export function CostCompareCards({ costs }: CostCompareCardsProps): React.ReactElement {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      <Card className={costs.recommended === "drive" ? "ring-2 ring-primary" : ""}>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Drive</CardTitle>
          {costs.recommended === "drive" && <Badge>Recommended</Badge>}
        </CardHeader>
        <CardContent>
          <div className="mb-2 text-2xl font-semibold">{money(costs.drive.amount)}</div>
          <div className="space-y-1 text-sm text-muted-foreground">
            <div>Mileage: {money(costs.drive.breakdown.mileage)}</div>
            <div>Extra lodging: {money(costs.drive.breakdown.extra_lodging)}</div>
            <div>Extra per diem: {money(costs.drive.breakdown.extra_per_diem)}</div>
          </div>
        </CardContent>
      </Card>
      <Card className={costs.recommended === "fly" ? "ring-2 ring-primary" : ""}>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Fly</CardTitle>
          {costs.recommended === "fly" && <Badge>Recommended</Badge>}
        </CardHeader>
        <CardContent>
          <div className="mb-2 text-2xl font-semibold">{money(costs.fly.amount)}</div>
          <div className="space-y-1 text-sm text-muted-foreground">
            <div>Airfare: {money(costs.fly.breakdown.airfare)}</div>
            <div>Rental car: {money(costs.fly.breakdown.rental_car)}</div>
            <div>Parking: {money(costs.fly.breakdown.parking)}</div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
